import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface IVehicleDetailsTaskVehicle {
  registrationNumber: string;
  isElectric?: boolean;
  model: string;
  make: string;
}

export interface IVehicleDetailsTask {
  vehicle: IVehicleDetailsTaskVehicle;
  taskTypeName: string;
}

@Component({
  selector: 'task-vehicle-details',
  templateUrl: './task-vehicle-details.component.html',
  styleUrls: ['./task-vehicle-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskVehicleDetailsComponent {
  @Input() task: IVehicleDetailsTask;
  @Input() showRegSearchLink: boolean = false;

  @Output() searchByRegClicked: EventEmitter<string> = new EventEmitter<string>();

  onSearchByReg(event: MouseEvent): void {
    event.stopPropagation();
    this.searchByRegClicked.emit(this.task.vehicle.registrationNumber);
  }
}
